/**
 * menuOffset.js — RESP-2026-11-03.
 *
 * The top menu (nav.fixed-top) is position:fixed and, on a phone, its height changes per user (1 row, or 2 when the
 * bell / profile icons wrap). Pages that reserve a fixed 70px for it end up with their first block hidden under it.
 * This measures the real height and publishes it as a CSS variable on the page root, e.g. --fr-menu-h, so the page's
 * own CSS can use `padding-top: max(70px, calc(var(--fr-menu-h, 70px) + 16px))` at phone width.
 *
 * Returns a cleanup function (call it from componentWillUnmount). Safe to call when there is no menu: it publishes 70px.
 * Used by FreightModule.js. (LogisticsV2.js and AccountsReceivable.js carry their own inline copy of the same idea.)
 */
export function watchMenuHeight(rootSelector, cssVar) {
    const apply = () => {
        const nav = document.querySelector('nav.fixed-top')
        const root = document.querySelector(rootSelector)
        if (root) root.style.setProperty(cssVar, (nav ? nav.offsetHeight : 70) + 'px')
    }
    apply()
    window.addEventListener('resize', apply)
    const timers = [setTimeout(apply, 400), setTimeout(apply, 1500)] // the menu can finish rendering after mount
    let observer = null
    const nav = document.querySelector('nav.fixed-top')
    if (nav && typeof ResizeObserver !== 'undefined') {
        observer = new ResizeObserver(apply)
        observer.observe(nav)
    }
    return () => {
        window.removeEventListener('resize', apply)
        timers.forEach(clearTimeout)
        if (observer) observer.disconnect()
    }
}
